import { ACTION_STATUS } from "../actionbar-detail.constant";
import { ButtonBase } from "./button.base";

export class ShoppingButtonModel extends ButtonBase {
    label: string = 'Shopping';
    action: string = ACTION_STATUS.shopping;
    matIconName: string = 'shopping_cart';
    colorClass: string = 'color-secondary-500';
}